import * as Api from '@/helpers/restApi'

export default {
  state: {
    FormData: {},
    OriginFormData: {},
    ContentBlock: {},
    ParentFileData: {},
    EditableImages: []
  },
  getters: {
    getFormData: state => state.FormData,
    getOriginFormData: state => state.OriginFormData,
    getContentBlock: state => state.ContentBlock,
    getParentFileData: state => state.ParentFileData
  },
  mutations: {
    SetFormData (state, val) {
      state.FormData = val
    },
    SetOriginFormData (state, val) {
      // глубокое копирование оригинального объекта формы
      state.OriginFormData = JSON.parse(JSON.stringify(val))
    },
    SetFormDataId (state, val) {
      // обновить id в форме после сохранения
      state.FormData.Id = val
    },
    SetContentBlock (state, val) {
      // вызывается из конструктора при добавлении контент блока
      state.ContentBlock = val
    },
    SetAddContentBlock (state) {
      state.FormData.ContentBlocks.push(state.ContentBlock)
    },
    SetAddVideoContentBlock (state, val) {
      state.ContentBlock.FilePath = val
    },
    SetFrontImageFileId (state, val) {
      state.FormData.FrontImageFileId = val
    },
    SetEditableImages (state, val) {
      // редактируемый массив картинок
      state.EditableImages = val
    },
    SetFormDataImages (state, val) {
      // перрезаписываем массив фоток в товарах
      state.FormData.Images = val
    },
    SetReplaceImages (state, val) {
      // console.log('val: ', val)
      // перебираем контент блоки, ищем тот в котором редактировали Images и заменяем его на новый
      state.FormData.ContentBlocks.forEach((block) => {
        if (JSON.stringify(block.Images) === JSON.stringify(state.EditableImages)) {
          // console.log('условие отработало ')
          block.Images = val
          // console.log('block.Images: ', block.Images)
        }
        // console.log('state.FormData: ', state.FormData)
      })
    }
  },
  actions: {
    setNewsDataTable ({ state, dispatch }) {
      // ПОЛУЧАЕМ ОБЪЕКТ ДЛЯ newsListTable страница новостей
      Api.getApi({
        url: '/api/Articles'
      })
        .then((data) => {
          if (data.Succeeded) {
            state.NewsDataTable = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setStatusNewsTable ({ dispatch }, obj) {
      // публикуем и снимаем с публикации прямо из таблицы
      Api.putApi({
        url: `/api/Articles/SetStatuses/${obj.Id}`,
        payload: obj
      })
        .then((data) => {
          if (data.Succeeded) {
            dispatch('setNewsDataTable')
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUploadImage ({ state, dispatch }, file) {
      // загрузка непосредственно файлов (оригиналы) картинки
      return Api.postApi({
        url: '/api/Files/LoadImage',
        payload: file
      })
        .then((data) => {
          if (data.Succeeded) {
            state.ParentFileData = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setUploadImageEducation ({ state, dispatch }, file) {
      // загрузка непосредственно файлов (оригиналы) картинки
      return Api.postApi({
        url: '/api/File/LoadImage',
        payload: file
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            state.ParentFileData = data.Data
          } else {
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setSaveEditImage ({ state, commit, dispatch }, val) {
      // отправка на сервер массива картинок
      return Api.postApi({
        url: '/api/Files/EditImage',
        payload: val
      })
        .then((data) => {
          if (data.Succeeded) {
            // это чтобы марка главной фотки отображдалась и до сохранения
            data.Data.forEach(item => {
              if (item.IsFrontImage) {
              // if (item.ParentFileId === state.FormData.FrontImageFileId) {
                commit('SetFrontImageFileId', item.FileId)
              }
            })

            // ---- для товаров ---
            if (state.FormData.Images) {
              console.log('state.FormData.Images: ', state.FormData.Images)
              // FormData.Images есть только в товарах соответственно отработает в товарах
              // state.FormData.Images = data.Data
              commit('SetFormDataImages', data.Data)
              return
            }

            // --- для новостей ----
            if (state.EditableImages.length === 0) {
              // если фотографии добавляются впервые то просто сохраняем в контент блок
              state.ContentBlock.Images = data.Data
              commit('SetAddContentBlock')
              return
            }
            // заменяем картинки в контент блоке на новые после перередактирования
            commit('SetReplaceImages', data.Data)
            // обнуляем редактируемый массив
            commit('SetEditableImages', [])
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    },
    setSaveEditImageEducation ({ state, commit, dispatch }, val) {
      // отправка на сервер массива картинок
      return Api.postApi({
        url: '/api/File/EditImage',
        payload: val
      }, 'education')
        .then((data) => {
          if (data.Succeeded) {
            // это чтобы марка главной фотки отображдалась и до сохранения
            data.Data.forEach(item => {
              if (item.IsFrontImage) {
              // if (item.ParentFileId === state.FormData.FrontImageFileId) {
                commit('SetFrontImageFileId', item.FileId)
              }
            })

            // --- для новостей ----
            if (state.EditableImages.length === 0) {
              // если фотографии добавляются впервые то просто сохраняем в контент блок
              state.ContentBlock.Images = data.Data
              commit('SetAddContentBlock')
              return
            }
            // заменяем картинки в контент блоке на новые после перередактирования
            commit('SetReplaceImages', data.Data)
            // обнуляем редактируемый массив
            commit('SetEditableImages', [])
          } else {
            // окно с ошибкой
            dispatch('setShowErrorModal', data)
          }
        })
    }
  }
}
